<script>
import moment from 'moment';
import API from '../services/api';

const api = new API();

module.exports = {
  template: '#add-car-template',
  data: function() {
    return {
      errors: {},
      values: {
        driven: '',
        license: ''
      },
      status: false,
      loading: false
    };
  },
  methods: {
    submitAddCarForm: function() {
      for (let key in this.values) {
        let el = this.values[key];
        if (el == '') this.errors[key] = true;
        else if (key == 'driven' && (!Number.isInteger(parseInt(el)) || /-/gi.test(el))) this.errors[key] = true;
        else delete this.errors[key];
      }

      if (Object.keys(this.errors).length === 0) {
        let self = this;
        self.loading = true;

        dataLayer.push({
          event: 'GAEvent',
          eventCategory: 'OmaLaakkonen',
          eventAction: 'AddCar',
          eventLabel: '',
          eventNonInteraction: 'false'
        });

        api
          .addCar(this.values)
          .then(res => {
            if (res.status == 1) {
              let brands = this.$store.state.brands;

              res.car.brand_icon = brands.reduce((result, brand) => {
                if (brand.name.toLowerCase() == res.car.brand_name.toLowerCase()) result = brand.icon;

                return result;
              });

              res.car = Object.assign(res.car, {
                maintenances: [],
                estimate: '-',
                estimate_asked: '-',
                estimate_ask_allowed: true,
                contact_info: {
                  stores: [],
                  persons: []
                },
                service_contracts: [],
                brand_phonenumbers: [],
                service_contracts: {
                  mainServices: [],
                  otherServices: [],
                  importerServices: []
                }
              });

              let active = this.$store.state.cars.active;

              active.unshift(res.car);

              this.$store.state.cars.active = active;

              self.loading = false;
              this.$router.push({ name: 'cars-children', params: { license: this.values.license.toUpperCase() } });
            } else {
              //console.log('error');
              self.loading = false;
              self.status = 'Emme onnistuneet hakemaan auton tietoja. Voit halutessasi jättää yhteydenottopyynnön asiakaspalveluun.';
            }
          })
          .catch(error => {
            //console.log(error.statusText);
          });
      }

      this.$forceUpdate();
    }
  },
  computed: {}
};
</script>